import React from 'react';
import {
  NonHatchAwaitingShiploaderActivity as NHA,
  Shiploader,
} from '@deckmans/domain';
import {ActivityListItem} from './ActivityListItem';
import {useHistory} from 'react-router';
import {useDataContext} from 'providers/DataContextProvider';

export interface NonHatchActivityProps {
  nonHatchAwaitingShiploaderActivity: NHA;
  vesselId: string;
  id?: string;
  startDate?: Date;
  endDate?: Date;
  shiploader: Shiploader;
}
export function NonHatchAwaitingShiploaderActivityComp({
  nonHatchAwaitingShiploaderActivity,
  vesselId,
  startDate,
  endDate,
  shiploader,
  id,
}: NonHatchActivityProps) {
  const {reason} = nonHatchAwaitingShiploaderActivity;
  const history = useHistory();
  const {printDecision} = useDataContext();

  const subtitle = printDecision(reason).join('/ ');

  return (
    <ActivityListItem
      color="info" //success/info/warning/error
      title="Awaiting Shiploader"
      subtitle={subtitle}
      startTime={startDate}
      endTime={endDate}
      editItem={() => {
        history.push(
          `/activity/non-hatch-activity/edit/${shiploader}/${vesselId}/${id}`
        );
      }}
    />
  );
}
